import React, { useEffect, useState } from 'react';
import Colon from '../Colon/Colon';
import Box from '../../../../../Box';
import Text from '../../../../../Text';
import styles from './CountdownTimer.module.css';

const getTimeLeft = (totalSeconds?: any) => {
  if (!totalSeconds) return { hours: '00', minutes: '00', seconds: '00' };
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return {
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
  };
};

const CountdownTimer = ({ initialSeconds }: any) => {
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    if (seconds <= 0) return;
    const intervalId = setInterval(() => {
      setSeconds((prevSeconds?: any) => Math.max(prevSeconds - 1, 0));
    }, 1000);

    // eslint-disable-next-line consistent-return
    return () => clearInterval(intervalId);
  }, []);

  const timeLeft = getTimeLeft(seconds);

  return (
    <Box className={styles.countdownTimer}>
      <Box className={styles.timeContainer}>
        <Text className={styles.timeLeft} type="display5">
          {timeLeft.hours}
        </Text>
        <Text className={styles.timeUnit} type="display6">
          H
        </Text>
      </Box>
      <Colon />
      <Box className={styles.timeContainer}>
        <Text className={styles.timeLeft} type="display5">
          {timeLeft.minutes}
        </Text>
        <Text className={styles.timeUnit} type="display6">
          M
        </Text>
      </Box>
      <Colon />
      <Box className={styles.timeContainer}>
        <Text className={styles.timeLeft} type="display5">
          {timeLeft.seconds}
        </Text>
        <Text className={styles.timeUnit} type="display6">
          S
        </Text>
      </Box>
    </Box>
  );
};

export default CountdownTimer;
